<template>
  <div style="margin-bottom:70px;height:100%">
    <baidu-map
      :class="isIconDown?'bm-view1':'bm-view' "
      ak="9gINxszg1iVzzxxULmjBLizVXHAWO1Xc"
      :scroll-wheel-zoom="true"
      :zoom="30"
      :center=center
    >
      <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-marker 
        v-for="(item,index) in dataListCoor" 
        :key="index"
        :position="{lng: item.equipRealTimeData.longitude, lat: item.equipRealTimeData.latitude}" 
        :dragging="true"
        @click="overShow(item.code)"
         >
        <bm-label :content="`${index + 1}`" :labelStyle="{height:'25px',lineHeight:'23px',padding:'0 5px',textAlign:'center',border:0,backgroundColor:'rgba(0,0,0,0)',color: '#ffffff', fontSize : '14px'}" :offset="{width: 0, height: 0}"/>
      </bm-marker>
      <my-overlays
        v-for="(item, index) in dataListCoor"
        :key="index + 'o'"
        v-show="dataCodeListCoor.indexOf(item.code) > -1"
        :position="{lng: item.equipRealTimeData.longitude, lat: item.equipRealTimeData.latitude}"
        :active="active"
        :text="item.str"
        :name="item.name"
        :code="item.code"
        :type="item.type"
        :zIndex="item.zIndex"
        :status="item.status"
        :oilValue="item.equipRealTimeData.oilmass"
        :workTimeValue="item.todayWorkTime"
        :workMileageValue="item.todayWorkMileage"
        :address="item.currentLocation"
        @closeOver="closeOverF"
        @goToInfo="goToInfoF"
        @mouseover.native="active = true"
        @mouseleave.native="active = false">
      </my-overlays>
    </baidu-map>
    <div :class="isIconDown?'upIconImg':'downIconImg'" @click="IconFun">
      <i :class="isIconDown?'el-icon-arrow-up':'el-icon-arrow-down'"> {{isIconDown?'展开设备列表':'隐藏设备列表'}}</i>
    </div>
    <div v-show="!isIconDown" class="equipSearchContent">
      <span class="searchInputText">设备名称</span>
      <el-input placeholder="请输入设备名称" v-model="search.name"></el-input>
      <span class="searchInputText">设备编号</span>
      <el-input placeholder="请输入设备编号" v-model="search.code"></el-input>
      <span class="searchInputText">设备类型</span>
      <el-select v-model="search.type" placeholder="请选择设备类型">
        <el-option v-for="item in equipTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <span class="searchInputText">设备状态</span>
      <el-select v-model="search.status" placeholder="请选择设备状态">
        <el-option v-for="item in equipStatusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button  type="danger" @click="doSearch">查找</el-button>
      <el-button  type="info" @click="doReset">重置</el-button>
    </div>

    <div v-show="!isIconDown" class="listContain equipListContent">
        <el-table
          :data="dataList"
          style="width: 100%"
          size="medium"
          :empty-text="emptyText"
          v-loading="listLoading"
          highlight-current-row
          @current-change="handleCurrentChange"
        >
            <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                    <span class="orderShow">{{scope.row.order}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="code" label="设备编号"></el-table-column>
            <el-table-column prop="typeName" label="设备类型"></el-table-column>
            <el-table-column prop="projectName" label="关联工程"></el-table-column>
            <el-table-column label="最新位置">
                <template slot-scope="scope" v-if="scope.row.equipRealTimeData.latitude">
                    {{scope.row.currentLocation}} ({{scope.row.equipRealTimeData.latitude}},{{scope.row.equipRealTimeData.longitude}})
                </template>
            </el-table-column>
            <el-table-column prop="workStatus" label="当前状态">
                <template slot-scope="scope">
                <span class="wordStatus_1" v-if="scope.row.workStatus==0">离线</span>
                <span class="wordStatus_2" v-if="scope.row.workStatus==1">怠速</span>
                <span class="wordStatus_3" v-if="scope.row.workStatus==2">作业中</span>
                </template>
            </el-table-column>
            <el-table-column label="本日运行时长">
              <template slot-scope="scope" v-if="scope.row.todayWorkTime">
                <span>{{scope.row.todayWorkTime}}H</span>
                </template>
            </el-table-column>
            <el-table-column prop="latestOnline" label="最近上线记录"></el-table-column>
            <el-table-column label="操作" width>
                <template slot-scope="scope">
                    <span class="lookMore" @click="toInfo(scope.row)">查看更多</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <el-pageCover
          v-show="!isIconDown"
          class="pageBlock"
          :pageMsg="pageMsg"
          @sizeChange="pageSizeChange"
          @currentChange="currentPageChange"
    ></el-pageCover>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmScale from "vue-baidu-map/components/controls/Scale.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import BmNavigation from "vue-baidu-map/components/controls/Navigation.vue";
import roleMixin from "../../utils/roleMixin"
import mixinList from "../../utils/mixinList"
import MyOverlays  from "../../components/common/MyOverlays";
import ElPageCover from "../../components/overall/ElPageCover"
import {
    getEquipTypeList,
    getEquipMonitorEquipList as fetchDtList
} from "../../utils/api"
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      indexShow: 0,
      active: false,
      listLoading:false,
      search: {
        code: '',
        name: '',
      },
      center: {
        lng: 116.404,
        lat: 39.915
      },
      pageMsg: {
            pageSize: 5,
            pageNo: 1,
            totalRecords: 0
        },
      equipStatusList: [
          {
              id: 0,
              name: '离线'
          },
          {
              id: 1,
              name: '怠速'
          },
          {
              id: 2,
              name: '作业中'
          },
      ],
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "位置监控",
          path: "/transfer/equipmentMonitor",
        },
      ],
      equipTypeList: [],
      dataList:[],
      dataListCoor: [],
      dataCodeListCoor: [],
      emptyText:'暂无数据',
      isIconDown:false,
      zIndexCode: 1
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    let that=this
    window.onresize = function () {
    
    var Width = window.innerWidth//浏览器窗口的内部宽度（包括滚动条）
    
    || document.documentElement.clientWidth
    
    || document.body.clientWidth;
    
    var Height = window.innerHeight//浏览器窗口的内部高度（包括滚动条）
    
    || document.documentElement.clientWidth
    
    || document.body.clientHeight;
    that.$nextTick(()=>{
      if(that.isIconDown){
        console.log(Width, Height,that);
        document.querySelector('.bm-view1').style.height=Height-(114*Width/1920)+'px'
      }else{
        document.querySelector('.bm-view').style.height=542*Width/1920+'px'
      }
    })
    }
    this.search.code = this.$route.params.code || ''
    getEquipTypeList({pageSize:100,}).then(res => {
        //console.log(res)
        this.equipTypeList = res.data.content.list
    })
    if(this.$route.params.equipcode){
      this.search.code=this.$route.params.equipcode
    }
    this.doSearch()
    console.log(this.dataList)
  },
  methods: {
    fetchDtList,
    //   doSearch: function(){
    //       getEquipMonitorEquipList(this.search).then(res=>{
    //           console.log(res)
    //           this.dataList = res.data.content.info.list
    //       })
    //   }
    closeOverF(e){
      console.log(e)
      let sort = this.dataCodeListCoor.indexOf(e)
      this.dataCodeListCoor.splice(sort,1)
    },
    goToInfoF(e,n){
      this.$router.push({name:'EquipmentInfo',params:{code:e,typeName:n,inArrow:'equipmentMonitor'}});
    },
    overShow(e){
      if(this.dataCodeListCoor.indexOf(e) < 0){
        this.dataCodeListCoor.push(e)
      }
      let list = JSON.parse(JSON.stringify(this.dataListCoor))
      for(let i=0;i<list.length;i++){
        if(list[i].code == e){
          list[i].zIndex = 101
        }else{
          list[i].zIndex = 100
        }
      }
      this.dataListCoor = list
    },
    IconFun:function(){
      this.isIconDown=!this.isIconDown
      var Width = window.innerWidth//浏览器窗口的内部宽度（包括滚动条）
    
      || document.documentElement.clientWidth
      
      || document.body.clientWidth;
      var Height = window.innerHeight//浏览器窗口的内部高度（包括滚动条）
    
        || document.documentElement.clientWidth
        
        || document.body.clientHeight;
        
      if(this.isIconDown){
        this.$nextTick(()=>{
          document.querySelector('.bm-view1').style.height=Height-(114*Width/1920)+'px'
        })
      }else{
        this.$nextTick(()=>{
          document.querySelector('.bm-view').style.height=542*Width/1920+'px'
        })
      }
    },
    
    toInfo: function(e){
        //console.log(e)
        this.$router.push({name:'EquipmentInfo',params:{code:e.code,typeName:e.typeName,inArrow:'equipmentMonitor'}});
    },
    doReset: function(){
      // this.search = {
      //   code: '',
      //   name: ''
      // }
      // this.getDataList(this.search, { listKey: "list" });
      this.$router.push({name:'SpeedBack',params:{}})
    },
    doSearch: function() {
        this.getDataList(this.search, { listKey: "list" });
    },
    handleCurrentChange: function(e){
      console.log(e)
      this.indexShow = e.order - 1
      let longitudeData = e.equipRealTimeData.longitude
      let latitudeData = e.equipRealTimeData.latitude
      if(longitudeData == null || latitudeData == null){
        this.$message({
          message: "无位置数据!",
          type: "warning"
        });
      }else{
        this.center= {
          lng: longitudeData,
          lat: latitudeData
        }
      }
      let list = JSON.parse(JSON.stringify(this.dataListCoor))
      for(let i=0;i<list.length;i++){
        if(list[i].code == e.code){
          list[i].zIndex = 101
        }else{
          list[i].zIndex = 100
        }
      }
      this.dataListCoor = list
    }
  },
  watch:{
    dataList:function(newValue){
      console.log(newValue)
      let setArr = []
      let codeArr = []
      for(let i=0;i<newValue.length;i++){
        if(newValue[i].equipRealTimeData.longitude != null){
          newValue[i].zIndex = 5
          setArr.push(newValue[i])
          codeArr.push(newValue[i].code)
          this.center = {
            lng: newValue[i].equipRealTimeData.longitude,
            lat: newValue[i].equipRealTimeData.latitude,
          }
        }
      }
      this.dataListCoor = setArr
      this.dataCodeListCoor = codeArr
    }
  },
  components: {
    BaiduMap,
    BmNavigation,
    BmScale,
    ElPageCover,
    BmMarker,
    BmLabel,
    MyOverlays
  },
};
</script>
<style lang="scss">
.equipSearchContent {
  .el-input {
    width: 180px !important;
    height: 36px !important;
    margin-left: 23px;
    margin-right: 23px;
    font-size: 14px !important;
    .el-input__inner {
      width: 180px !important;
      height: 36px !important;
      border-radius: 1px !important;
    }
  }
  
}
</style>
<style lang="scss" scoped="">
.bm-view {
  width: 100%;
  height: 542px;
}
.bm-view1 {
  width: 100%;
  height: 852px;
  // height: 100%;
}
.upIconImg{
  width: 130px;
  height: 26px;
  background: #f2f2f2;
  position: absolute;
  font-size: 16px;
  text-align: center;
  line-height: 26px;
  bottom: 0px;
  left: 50%;
  margin-left: -15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
}
.downIconImg{
  width: 130px;
  height: 26px;
  background: #f2f2f2;
  position: absolute;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  top: 574px;
  left: 50%;
  margin-left: -15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
}
.listContain{
  width: 98.5%;
  margin: 0 auto;
  margin-top: 10px;
}
.equipSearchContent {
  height: 60px;
  width: 98.5%;
  margin: 0 auto;
  margin-top: 13px;
  background-color: #ffffff;
  padding-top: 12px;
}
.searchInputText {
  height: 36px;
  line-height: 36px;
  display: inline-block;
  margin-left: 35px;
  color: #222222;
  font-size: 14px;
}

.lookMore{
    display: inline-block;
    font-size: 14px;
    color: #E24747;
    background:rgba(255,232,232,1);
    border:1px solid rgba(226, 71, 71, 1);
    border-radius:16px;
    padding: 4px 16px;
    margin-left: 10px;
    cursor: pointer;
}
.orderShow{
    display: inline-block;
    height: 25px;
    width: 25px;
    line-height: 25px;
    background: #E96B5A;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
}
</style>